function triggerTicker(element: Element) {
  const counter = element.querySelector<HTMLSpanElement>(
    ".ticker__ticker__number"
  );

  if (counter) {
    const endNumber = +(counter.getAttribute("data-end-number") ?? 0);
    const currentNumber = +(counter.innerText.replace(/,/g, "") ?? 0);

    if (currentNumber < endNumber) {
      let animateInterval = setInterval(() => {
        const startNumber = +(counter.getAttribute("data-start-number") ?? 0);
        const endNumber = +(counter.getAttribute("data-end-number") ?? 0);
        const milliseconds = +(counter.getAttribute("data-time") ?? 1000);
        const currentNumber = +(counter.innerText.replace(/,/g, "") ?? 0);

        const increment =
          milliseconds > 0
            ? (endNumber - startNumber) / (milliseconds / 5)
            : endNumber;

        if (currentNumber < endNumber) {
          counter.innerText = Intl.NumberFormat().format(
            Math.ceil(currentNumber + increment)
          );
        } else {
          counter.innerText = Intl.NumberFormat().format(endNumber);
          clearInterval(animateInterval);
        }
      });
    }
  }
}

document.addEventListener("aos:in", ({ detail }) => {
  if (
    detail.classList.contains("ticker__ticker") &&
    detail.classList.contains("aos-animate")
  ) {
    triggerTicker(detail);
  }
});
window.addEventListener("load", () => {
  // AOS disabled on mobile. Trigger animation anyways.
  if (window.innerWidth < 1024) {
    document.querySelectorAll(".ticker__ticker").forEach((element) => {
      triggerTicker(element);
    });
  }
});
